import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  SECTIONS_LIST,
  SECTIONS_NEW,
  SECTIONS_EDIT,
  SECTIONS_DELETE,
  SECTIONS_COMPANIES_LIST,
} from "./actionTypes"

import {
  sectionsListSuccess,
  sectionsListError,
  sectionsNewSuccess,
  sectionsNewError,
  sectionsDeleteSuccess,
  sectionsDeleteError,
  sectionsCompaniesListSuccess,
  sectionsCompaniesListError,
} from "./actions"

import {
  apiGetSectionsList,
  apiPostSectionsNew,
  apiPatchSectionsEdit,
  apiDeleteSectionsDelete,
  apiGetSectionsCompaniesList,
} from "../../api/calls/sections"

function* sectionsList({payload: data}) {
  try {
    const response = yield call(apiGetSectionsList, data)
    yield put(sectionsListSuccess(response))
  } catch (error) {
    yield put(sectionsListError(error))
  }
}

function* sectionsNew({payload: data}) {
  try {
    const response = yield call(apiPostSectionsNew, data)
    yield put(sectionsNewSuccess(response))
  } catch (error) {
    yield put(sectionsNewError(error))
  }
}

function* sectionsEdit({payload: data}) {
  try {
    const response = yield call(apiPatchSectionsEdit, data)
    yield put(sectionsNewSuccess(response))
  } catch (error) {
    yield put(sectionsNewError(error))
  }
}

function* sectionsDelete({payload: data}) {
  try {
    const response = yield call(apiDeleteSectionsDelete, data)
    yield put(sectionsDeleteSuccess(response))
  } catch (error) {
    yield put(sectionsDeleteError(error))
  }
}

function* sectionsCompaniesList({payload: data}) {
  try {
    const response = yield call(apiGetSectionsCompaniesList, data)
    yield put(sectionsCompaniesListSuccess(response))
  } catch (error) {
    yield put(sectionsCompaniesListError(error))
  }
}

export function* watchSectionsList() {
  yield takeEvery(SECTIONS_LIST, sectionsList);
}

export function* watchSectionsNew() {
  yield takeEvery(SECTIONS_NEW, sectionsNew);
}

export function* watchSectionsEdit() {
  yield takeEvery(SECTIONS_EDIT, sectionsEdit);
}

export function* watchSectionsDelete() {
  yield takeEvery(SECTIONS_DELETE, sectionsDelete);
}

export function* watchSectionsCompaniesList() {
  yield takeEvery(SECTIONS_COMPANIES_LIST, sectionsCompaniesList);
}

function* sectionsSaga() {
  yield all([
    fork(watchSectionsList),
    fork(watchSectionsNew),
    fork(watchSectionsEdit),
    fork(watchSectionsDelete),
    fork(watchSectionsCompaniesList),
  ]);
}

export default sectionsSaga
